
import { User } from "@auth0/auth0-spa-js";
import { Component, Vue, PropSync, Prop } from "vue-property-decorator";
import { State, Getter } from "vuex-class";

@Component({})
export default class SiteHeader extends Vue {
  fixed = true;
  clipped = true;

  navigation = [
    {
      name: "Current Agenda",
      url: "/",
      uuid: "current",
    },
    {
      name: "Archived Agendas",
      url: "/agendas",
      uuid: "archive",
    },
  ];

  @Prop({ type: String })
  title!: string;

  @PropSync("drawer", { type: Boolean })
  syncedDrawer!: boolean;

  @State("user")
  currentUser!: User;

  @Getter
  hasPermission!: (permission: string) => boolean;

  get isLoggedIn(): boolean {
    return this.$auth.isAuthenticated && !!this.currentUser;
  }

  users(): void {
    if (this.$router.currentRoute.path != "/users") {
      this.$router.push("/users");
    }
  }

  profile(): void {
    if (this.$router.currentRoute.path != "/me") {
      this.$router.push("/me");
    }
  }

  // Log the user in
  login(): void {
    this.$auth.loginWithRedirect();
  }
  // Log the user out
  logout(): void {
    this.$auth.logout({
      returnTo: window.location.origin,
    });
  }
}
